var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.albums[_vm.id].size),function(i){return _c('progressive-img',{key:i,attrs:{"id":"pimg","src":_vm.getImageSource(_vm.id, i),"placeholder":_vm.getImagePlaceholder(_vm.id, i)}})}),1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6845c026","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Album.vue
// module id = null
// module chunks = 